export type TradeParnerProps = {
  awsGroupName: string;
  name: string;
}

export type CountryISOMap = {
  Country: string;
  alpha2: string;
  dialCode: string;
  tradePartner?: TradeParnerProps;
};

export const Countries: CountryISOMap[] = [
  {
    "Country": "Afghanistan",
    "dialCode": "93",
    "alpha2": "AF"
  },
  {
    "Country": "Aland Islands",
    "dialCode": "358",
    "alpha2": "AX"
  },
  {
    "Country": "Albania",
    "dialCode": "355",
    "alpha2": "AL"
  },
  {
    "Country": "Algeria",
    "dialCode": "213",
    "alpha2": "DZ"
  },
  {
    "Country": "AmericanSamoa",
    "dialCode": "1684",
    "alpha2": "AS"
  },
  {
    "Country": "Andorra",
    "dialCode": "376",
    "alpha2": "AD"
  },
  {
    "Country": "Angola",
    "dialCode": "244",
    "alpha2": "AO"
  },
  {
    "Country": "Anguilla",
    "dialCode": "1264",
    "alpha2": "AI"
  },
  {
    "Country": "Antarctica",
    "dialCode": "672",
    "alpha2": "AQ"
  },
  {
    "Country": "Antigua and Barbuda",
    "dialCode": "1268",
    "alpha2": "AG"
  },
  {
    "Country": "Argentina",
    "dialCode": "54",
    "alpha2": "AR",
    "tradePartner": {
      "awsGroupName": "ag:org:villanueva",
      "name": "Villanueva"
    }
  },
  {
    "Country": "Armenia",
    "dialCode": "374",
    "alpha2": "AM"
  },
  {
    "Country": "Aruba",
    "dialCode": "297",
    "alpha2": "AW"
  },
  {
    "Country": "Ascension Island",
    "dialCode": "247",
    "alpha2": "AC"
  },
  {
    "Country": "Australia",
    "dialCode": "61",
    "alpha2": "AU"
  },
  {
    "Country": "Austria",
    "dialCode": "43",
    "alpha2": "AT"
  },
  {
    "Country": "Azerbaijan",
    "dialCode": "994",
    "alpha2": "AZ"
  },
  {
    "Country": "Bahamas",
    "dialCode": "1242",
    "alpha2": "BS"
  },
  {
    "Country": "Bahrain",
    "dialCode": "973",
    "alpha2": "BH"
  },
  {
    "Country": "Bangladesh",
    "dialCode": "880",
    "alpha2": "BD"
  },
  {
    "Country": "Barbados",
    "dialCode": "1246",
    "alpha2": "BB"
  },
  {
    "Country": "Belarus",
    "dialCode": "375",
    "alpha2": "BY"
  },
  {
    "Country": "Belgium",
    "dialCode": "32",
    "alpha2": "BE"
  },
  {
    "Country": "Belize",
    "dialCode": "501",
    "alpha2": "BZ"
  },
  {
    "Country": "Benin",
    "dialCode": "229",
    "alpha2": "BJ"
  },
  {
    "Country": "Bermuda",
    "dialCode": "1441",
    "alpha2": "BM"
  },
  {
    "Country": "Bhutan",
    "dialCode": "975",
    "alpha2": "BT"
  },
  {
    "Country": "Bolivia",
    "dialCode": "591",
    "alpha2": "BO"
  },
  {
    "Country": "Bosnia and Herzegovina",
    "dialCode": "387",
    "alpha2": "BA"
  },
  {
    "Country": "Botswana",
    "dialCode": "267",
    "alpha2": "BW"
  },
  {
    "Country": "Brazil",
    "dialCode": "55",
    "alpha2": "BR"
  },
  {
    "Country": "British Indian Ocean Territory",
    "dialCode": "246",
    "alpha2": "IO"
  },
  {
    "Country": "Brunei Darussalam",
    "dialCode": "673",
    "alpha2": "BN"
  },
  {
    "Country": "Bulgaria",
    "dialCode": "359",
    "alpha2": "BG"
  },
  {
    "Country": "Burkina Faso",
    "dialCode": "226",
    "alpha2": "BF"
  },
  {
    "Country": "Burundi",
    "dialCode": "257",
    "alpha2": "BI"
  },
  {
    "Country": "Cambodia",
    "dialCode": "855",
    "alpha2": "KH"
  },
  {
    "Country": "Cameroon",
    "dialCode": "237",
    "alpha2": "CM"
  },
  {
    "Country": "Canada",
    "dialCode": "1",
    "alpha2": "CA"
  },
  {
    "Country": "Cape Verde",
    "dialCode": "238",
    "alpha2": "CV"
  },
  {
    "Country": "Cayman Islands",
    "dialCode": "1345",
    "alpha2": "KY"
  },
  {
    "Country": "Central African Republic",
    "dialCode": "236",
    "alpha2": "CF"
  },
  {
    "Country": "Chad",
    "dialCode": "235",
    "alpha2": "TD"
  },
  {
    "Country": "Chile",
    "dialCode": "56",
    "alpha2": "CL"
  },
  {
    "Country": "China",
    "dialCode": "86",
    "alpha2": "CN"
  },
  {
    "Country": "Christmas Island",
    "dialCode": "61",
    "alpha2": "CX"
  },
  {
    "Country": "Cocos (Keeling) Islands",
    "dialCode": "61",
    "alpha2": "CC"
  },
  {
    "Country": "Colombia",
    "dialCode": "57",
    "alpha2": "CO"
  },
  {
    "Country": "Comoros",
    "dialCode": "269",
    "alpha2": "KM"
  },
  {
    "Country": "Congo",
    "dialCode": "242",
    "alpha2": "CG"
  },
  {
    "Country": "Cook Islands",
    "dialCode": "682",
    "alpha2": "CK"
  },
  {
    "Country": "Costa Rica",
    "dialCode": "506",
    "alpha2": "CR"
  },
  {
    "Country": "Croatia",
    "dialCode": "385",
    "alpha2": "HR"
  },
  {
    "Country": "Cuba",
    "dialCode": "53",
    "alpha2": "CU"
  },
  {
    "Country": "Cyprus",
    "dialCode": "357",
    "alpha2": "CY"
  },
  {
    "Country": "Czech Republic",
    "dialCode": "420",
    "alpha2": "CZ"
  },
  {
    "Country": "Democratic Republic of the Congo",
    "dialCode": "243",
    "alpha2": "CD"
  },
  {
    "Country": "Denmark",
    "dialCode": "45",
    "alpha2": "DK"
  },
  {
    "Country": "Djibouti",
    "dialCode": "253",
    "alpha2": "DJ"
  },
  {
    "Country": "Dominica",
    "dialCode": "1767",
    "alpha2": "DM"
  },
  {
    "Country": "Dominican Republic",
    "dialCode": "1849",
    "alpha2": "DO"
  },
  {
    "Country": "Ecuador",
    "dialCode": "593",
    "alpha2": "EC"
  },
  {
    "Country": "Egypt",
    "dialCode": "20",
    "alpha2": "EG"
  },
  {
    "Country": "El Salvador",
    "dialCode": "503",
    "alpha2": "SV"
  },
  {
    "Country": "Equatorial Guinea",
    "dialCode": "240",
    "alpha2": "GQ"
  },
  {
    "Country": "Eritrea",
    "dialCode": "291",
    "alpha2": "ER"
  },
  {
    "Country": "Estonia",
    "dialCode": "372",
    "alpha2": "EE"
  },
  {
    "Country": "Eswatini",
    "dialCode": "268",
    "alpha2": "SZ"
  },
  {
    "Country": "Ethiopia",
    "dialCode": "251",
    "alpha2": "ET"
  },
  {
    "Country": "Falkland Islands (Malvinas)",
    "dialCode": "500",
    "alpha2": "FK"
  },
  {
    "Country": "Faroe Islands",
    "dialCode": "298",
    "alpha2": "FO"
  },
  {
    "Country": "Fiji",
    "dialCode": "679",
    "alpha2": "FJ"
  },
  {
    "Country": "Finland",
    "dialCode": "358",
    "alpha2": "FI"
  },
  {
    "Country": "France",
    "dialCode": "33",
    "alpha2": "FR"
  },
  {
    "Country": "French Guiana",
    "dialCode": "594",
    "alpha2": "GF"
  },
  {
    "Country": "French Polynesia",
    "dialCode": "689",
    "alpha2": "PF"
  },
  {
    "Country": "Gabon",
    "dialCode": "241",
    "alpha2": "GA"
  },
  {
    "Country": "Gambia",
    "dialCode": "220",
    "alpha2": "GM"
  },
  {
    "Country": "Georgia",
    "dialCode": "995",
    "alpha2": "GE"
  },
  {
    "Country": "Germany",
    "dialCode": "49",
    "alpha2": "DE"
  },
  {
    "Country": "Ghana",
    "dialCode": "233",
    "alpha2": "GH"
  },
  {
    "Country": "Gibraltar",
    "dialCode": "350",
    "alpha2": "GI"
  },
  {
    "Country": "Greece",
    "dialCode": "30",
    "alpha2": "GR"
  },
  {
    "Country": "Greenland",
    "dialCode": "299",
    "alpha2": "GL"
  },
  {
    "Country": "Grenada",
    "dialCode": "1473",
    "alpha2": "GD"
  },
  {
    "Country": "Guadeloupe",
    "dialCode": "590",
    "alpha2": "GP"
  },
  {
    "Country": "Guam",
    "dialCode": "1671",
    "alpha2": "GU"
  },
  {
    "Country": "Guatemala",
    "dialCode": "502",
    "alpha2": "GT"
  },
  {
    "Country": "Guernsey",
    "dialCode": "44",
    "alpha2": "GG"
  },
  {
    "Country": "Guinea",
    "dialCode": "224",
    "alpha2": "GN"
  },
  {
    "Country": "Guinea-Bissau",
    "dialCode": "245",
    "alpha2": "GW"
  },
  {
    "Country": "Guyana",
    "dialCode": "592",
    "alpha2": "GY"
  },
  {
    "Country": "Haiti",
    "dialCode": "509",
    "alpha2": "HT"
  },
  {
    "Country": "Holy See (Vatican City State)",
    "dialCode": "379",
    "alpha2": "VA"
  },
  {
    "Country": "Honduras",
    "dialCode": "504",
    "alpha2": "HN"
  },
  {
    "Country": "Hong Kong",
    "dialCode": "852",
    "alpha2": "HK"
  },
  {
    "Country": "Hungary",
    "dialCode": "36",
    "alpha2": "HU"
  },
  {
    "Country": "Iceland",
    "dialCode": "354",
    "alpha2": "IS"
  },
  {
    "Country": "India",
    "dialCode": "91",
    "alpha2": "IN"
  },
  {
    "Country": "Indonesia",
    "dialCode": "62",
    "alpha2": "ID"
  },
  {
    "Country": "Iran",
    "dialCode": "98",
    "alpha2": "IR"
  },
  {
    "Country": "Iraq",
    "dialCode": "964",
    "alpha2": "IQ"
  },
  {
    "Country": "Ireland",
    "dialCode": "353",
    "alpha2": "IE"
  },
  {
    "Country": "Isle of Man",
    "dialCode": "44",
    "alpha2": "IM"
  },
  {
    "Country": "Israel",
    "dialCode": "972",
    "alpha2": "IL"
  },
  {
    "Country": "Italy",
    "dialCode": "39",
    "alpha2": "IT"
  },
  {
    "Country": "Ivory Coast / Cote d'Ivoire",
    "dialCode": "225",
    "alpha2": "CI"
  },
  {
    "Country": "Jamaica",
    "dialCode": "1876",
    "alpha2": "JM"
  },
  {
    "Country": "Japan",
    "dialCode": "81",
    "alpha2": "JP"
  },
  {
    "Country": "Jersey",
    "dialCode": "44",
    "alpha2": "JE"
  },
  {
    "Country": "Jordan",
    "dialCode": "962",
    "alpha2": "JO"
  },
  {
    "Country": "Kazakhstan",
    "dialCode": "77",
    "alpha2": "KZ"
  },
  {
    "Country": "Kenya",
    "dialCode": "254",
    "alpha2": "KE"
  },
  {
    "Country": "Kiribati",
    "dialCode": "686",
    "alpha2": "KI"
  },
  {
    "Country": "Korea, Democratic People's Republic of Korea",
    "dialCode": "850",
    "alpha2": "KP"
  },
  {
    "Country": "Korea, Republic of South Korea",
    "dialCode": "82",
    "alpha2": "KR"
  },
  {
    "Country": "Kosovo",
    "dialCode": "383",
    "alpha2": "XK"
  },
  {
    "Country": "Kuwait",
    "dialCode": "965",
    "alpha2": "KW"
  },
  {
    "Country": "Kyrgyzstan",
    "dialCode": "996",
    "alpha2": "KG"
  },
  {
    "Country": "Laos",
    "dialCode": "856",
    "alpha2": "LA"
  },
  {
    "Country": "Latvia",
    "dialCode": "371",
    "alpha2": "LV"
  },
  {
    "Country": "Lebanon",
    "dialCode": "961",
    "alpha2": "LB"
  },
  {
    "Country": "Lesotho",
    "dialCode": "266",
    "alpha2": "LS"
  },
  {
    "Country": "Liberia",
    "dialCode": "231",
    "alpha2": "LR"
  },
  {
    "Country": "Libya",
    "dialCode": "218",
    "alpha2": "LY"
  },
  {
    "Country": "Liechtenstein",
    "dialCode": "423",
    "alpha2": "LI"
  },
  {
    "Country": "Lithuania",
    "dialCode": "370",
    "alpha2": "LT"
  },
  {
    "Country": "Luxembourg",
    "dialCode": "352",
    "alpha2": "LU"
  },
  {
    "Country": "Macau",
    "dialCode": "853",
    "alpha2": "MO"
  },
  {
    "Country": "Madagascar",
    "dialCode": "261",
    "alpha2": "MG"
  },
  {
    "Country": "Malawi",
    "dialCode": "265",
    "alpha2": "MW"
  },
  {
    "Country": "Malaysia",
    "dialCode": "60",
    "alpha2": "MY"
  },
  {
    "Country": "Maldives",
    "dialCode": "960",
    "alpha2": "MV"
  },
  {
    "Country": "Mali",
    "dialCode": "223",
    "alpha2": "ML"
  },
  {
    "Country": "Malta",
    "dialCode": "356",
    "alpha2": "MT"
  },
  {
    "Country": "Marshall Islands",
    "dialCode": "692",
    "alpha2": "MH"
  },
  {
    "Country": "Martinique",
    "dialCode": "596",
    "alpha2": "MQ"
  },
  {
    "Country": "Mauritania",
    "dialCode": "222",
    "alpha2": "MR"
  },
  {
    "Country": "Mauritius",
    "dialCode": "230",
    "alpha2": "MU"
  },
  {
    "Country": "Mayotte",
    "dialCode": "262",
    "alpha2": "YT"
  },
  {
    "Country": "Mexico",
    "dialCode": "52",
    "alpha2": "MX"
  },
  {
    "Country": "Micronesia, Federated States of Micronesia",
    "dialCode": "691",
    "alpha2": "FM"
  },
  {
    "Country": "Moldova",
    "dialCode": "373",
    "alpha2": "MD"
  },
  {
    "Country": "Monaco",
    "dialCode": "377",
    "alpha2": "MC"
  },
  {
    "Country": "Mongolia",
    "dialCode": "976",
    "alpha2": "MN"
  },
  {
    "Country": "Montenegro",
    "dialCode": "382",
    "alpha2": "ME"
  },
  {
    "Country": "Montserrat",
    "dialCode": "1664",
    "alpha2": "MS"
  },
  {
    "Country": "Morocco",
    "dialCode": "212",
    "alpha2": "MA"
  },
  {
    "Country": "Mozambique",
    "dialCode": "258",
    "alpha2": "MZ"
  },
  {
    "Country": "Myanmar",
    "dialCode": "95",
    "alpha2": "MM"
  },
  {
    "Country": "Namibia",
    "dialCode": "264",
    "alpha2": "NA"
  },
  {
    "Country": "Nauru",
    "dialCode": "674",
    "alpha2": "NR"
  },
  {
    "Country": "Nepal",
    "dialCode": "977",
    "alpha2": "NP"
  },
  {
    "Country": "Netherlands",
    "dialCode": "31",
    "alpha2": "NL"
  },
  {
    "Country": "Netherlands Antilles",
    "dialCode": "599",
    "alpha2": "AN"
  },
  {
    "Country": "New Caledonia",
    "dialCode": "687",
    "alpha2": "NC"
  },
  {
    "Country": "New Zealand",
    "dialCode": "64",
    "alpha2": "NZ"
  },
  {
    "Country": "Nicaragua",
    "dialCode": "505",
    "alpha2": "NI"
  },
  {
    "Country": "Niger",
    "dialCode": "227",
    "alpha2": "NE"
  },
  {
    "Country": "Nigeria",
    "dialCode": "234",
    "alpha2": "NG"
  },
  {
    "Country": "Niue",
    "dialCode": "683",
    "alpha2": "NU"
  },
  {
    "Country": "Norfolk Island",
    "dialCode": "672",
    "alpha2": "NF"
  },
  {
    "Country": "North Macedonia",
    "dialCode": "389",
    "alpha2": "MK"
  },
  {
    "Country": "Northern Mariana Islands",
    "dialCode": "1670",
    "alpha2": "MP"
  },
  {
    "Country": "Norway",
    "dialCode": "47",
    "alpha2": "NO"
  },
  {
    "Country": "Oman",
    "dialCode": "968",
    "alpha2": "OM"
  },
  {
    "Country": "Pakistan",
    "dialCode": "92",
    "alpha2": "PK"
  },
  {
    "Country": "Palau",
    "dialCode": "680",
    "alpha2": "PW"
  },
  {
    "Country": "Palestine",
    "dialCode": "970",
    "alpha2": "PS"
  },
  {
    "Country": "Panama",
    "dialCode": "507",
    "alpha2": "PA"
  },
  {
    "Country": "Papua New Guinea",
    "dialCode": "675",
    "alpha2": "PG"
  },
  {
    "Country": "Paraguay",
    "dialCode": "595",
    "alpha2": "PY"
  },
  {
    "Country": "Peru",
    "dialCode": "51",
    "alpha2": "PE"
  },
  {
    "Country": "Philippines",
    "dialCode": "63",
    "alpha2": "PH"
  },
  {
    "Country": "Pitcairn",
    "dialCode": "872",
    "alpha2": "PN"
  },
  {
    "Country": "Poland",
    "dialCode": "48",
    "alpha2": "PL"
  },
  {
    "Country": "Portugal",
    "dialCode": "351",
    "alpha2": "PT"
  },
  {
    "Country": "Puerto Rico",
    "dialCode": "1939",
    "alpha2": "PR"
  },
  {
    "Country": "Qatar",
    "dialCode": "974",
    "alpha2": "QA"
  },
  {
    "Country": "Reunion",
    "dialCode": "262",
    "alpha2": "RE"
  },
  {
    "Country": "Romania",
    "dialCode": "40",
    "alpha2": "RO"
  },
  {
    "Country": "Russia",
    "dialCode": "7",
    "alpha2": "RU"
  },
  {
    "Country": "Rwanda",
    "dialCode": "250",
    "alpha2": "RW"
  },
  {
    "Country": "Saint Barthelemy",
    "dialCode": "590",
    "alpha2": "BL"
  },
  {
    "Country": "Saint Helena, Ascension and Tristan Da Cunha",
    "dialCode": "290",
    "alpha2": "SH"
  },
  {
    "Country": "Saint Kitts and Nevis",
    "dialCode": "1869",
    "alpha2": "KN"
  },
  {
    "Country": "Saint Lucia",
    "dialCode": "1758",
    "alpha2": "LC"
  },
  {
    "Country": "Saint Martin",
    "dialCode": "590",
    "alpha2": "MF"
  },
  {
    "Country": "Saint Pierre and Miquelon",
    "dialCode": "508",
    "alpha2": "PM"
  },
  {
    "Country": "Saint Vincent and the Grenadines",
    "dialCode": "1784",
    "alpha2": "VC"
  },
  {
    "Country": "Samoa",
    "dialCode": "685",
    "alpha2": "WS"
  },
  {
    "Country": "San Marino",
    "dialCode": "378",
    "alpha2": "SM"
  },
  {
    "Country": "Sao Tome and Principe",
    "dialCode": "239",
    "alpha2": "ST"
  },
  {
    "Country": "Saudi Arabia",
    "dialCode": "966",
    "alpha2": "SA"
  },
  {
    "Country": "Senegal",
    "dialCode": "221",
    "alpha2": "SN"
  },
  {
    "Country": "Serbia",
    "dialCode": "381",
    "alpha2": "RS"
  },
  {
    "Country": "Seychelles",
    "dialCode": "248",
    "alpha2": "SC"
  },
  {
    "Country": "Sierra Leone",
    "dialCode": "232",
    "alpha2": "SL"
  },
  {
    "Country": "Singapore",
    "dialCode": "65",
    "alpha2": "SG"
  },
  {
    "Country": "Sint Maarten",
    "dialCode": "1721",
    "alpha2": "SX"
  },
  {
    "Country": "Slovakia",
    "dialCode": "421",
    "alpha2": "SK"
  },
  {
    "Country": "Slovenia",
    "dialCode": "386",
    "alpha2": "SI"
  },
  {
    "Country": "Solomon Islands",
    "dialCode": "677",
    "alpha2": "SB"
  },
  {
    "Country": "Somalia",
    "dialCode": "252",
    "alpha2": "SO"
  },
  {
    "Country": "South Africa",
    "dialCode": "27",
    "alpha2": "ZA",
    "tradePartner": {
      "awsGroupName": "ag:org:axxon",
      "name": "Axxon"
    }
  },
  {
    "Country": "South Georgia and the South Sandwich Islands",
    "dialCode": "500",
    "alpha2": "GS"
  },
  {
    "Country": "South Sudan",
    "dialCode": "211",
    "alpha2": "SS"
  },
  {
    "Country": "Spain",
    "dialCode": "34",
    "alpha2": "ES"
  },
  {
    "Country": "Sri Lanka",
    "dialCode": "94",
    "alpha2": "LK"
  },
  {
    "Country": "Sudan",
    "dialCode": "249",
    "alpha2": "SD"
  },
  {
    "Country": "Suriname",
    "dialCode": "597",
    "alpha2": "SR"
  },
  {
    "Country": "Svalbard and Jan Mayen",
    "dialCode": "47",
    "alpha2": "SJ"
  },
  {
    "Country": "Sweden",
    "dialCode": "46",
    "alpha2": "SE"
  },
  {
    "Country": "Switzerland",
    "dialCode": "41",
    "alpha2": "CH"
  },
  {
    "Country": "Syrian Arab Republic",
    "dialCode": "963",
    "alpha2": "SY"
  },
  {
    "Country": "Taiwan",
    "dialCode": "886",
    "alpha2": "TW"
  },
  {
    "Country": "Tajikistan",
    "dialCode": "992",
    "alpha2": "TJ"
  },
  {
    "Country": "Tanzania, United Republic of Tanzania",
    "dialCode": "255",
    "alpha2": "TZ"
  },
  {
    "Country": "Thailand",
    "dialCode": "66",
    "alpha2": "TH"
  },
  {
    "Country": "Timor-Leste",
    "dialCode": "670",
    "alpha2": "TL"
  },
  {
    "Country": "Togo",
    "dialCode": "228",
    "alpha2": "TG"
  },
  {
    "Country": "Tokelau",
    "dialCode": "690",
    "alpha2": "TK"
  },
  {
    "Country": "Tonga",
    "dialCode": "676",
    "alpha2": "TO"
  },
  {
    "Country": "Trinidad and Tobago",
    "dialCode": "1868",
    "alpha2": "TT"
  },
  {
    "Country": "Tunisia",
    "dialCode": "216",
    "alpha2": "TN"
  },
  {
    "Country": "Turkey",
    "dialCode": "90",
    "alpha2": "TR"
  },
  {
    "Country": "Turkmenistan",
    "dialCode": "993",
    "alpha2": "TM"
  },
  {
    "Country": "Turks and Caicos Islands",
    "dialCode": "1649",
    "alpha2": "TC"
  },
  {
    "Country": "Tuvalu",
    "dialCode": "688",
    "alpha2": "TV"
  },
  {
    "Country": "Uganda",
    "dialCode": "256",
    "alpha2": "UG"
  },
  {
    "Country": "Ukraine",
    "dialCode": "380",
    "alpha2": "UA"
  },
  {
    "Country": "United Arab Emirates",
    "dialCode": "971",
    "alpha2": "AE"
  },
  {
    "Country": "United Kingdom",
    "dialCode": "44",
    "alpha2": "UK"
  },
  {
    "Country": "United States",
    "dialCode": "1",
    "alpha2": "US"
  },
  {
    "Country": "Uruguay",
    "dialCode": "598",
    "alpha2": "UY"
  },
  {
    "Country": "Uzbekistan",
    "dialCode": "998",
    "alpha2": "UZ"
  },
  {
    "Country": "Vanuatu",
    "dialCode": "678",
    "alpha2": "VU"
  },
  {
    "Country": "Venezuela, Bolivarian Republic of Venezuela",
    "dialCode": "58",
    "alpha2": "VE"
  },
  {
    "Country": "Vietnam",
    "dialCode": "84",
    "alpha2": "VN"
  },
  {
    "Country": "Virgin Islands, British",
    "dialCode": "1284",
    "alpha2": "VG"
  },
  {
    "Country": "Virgin Islands, U.S.",
    "dialCode": "1340",
    "alpha2": "VI"
  },
  {
    "Country": "Wallis and Futuna",
    "dialCode": "681",
    "alpha2": "WF"
  },
  {
    "Country": "Yemen",
    "dialCode": "967",
    "alpha2": "YE"
  },
  {
    "Country": "Zambia",
    "dialCode": "260",
    "alpha2": "ZM"
  },
  {
    "Country": "Zimbabwe",
    "dialCode": "263",
    "alpha2": "ZW"
  }
];

/**
 * Lookup function to assist finding a country record
 * by either its Country name, or its 2 digit ISO code
 *
 * @param lookup String filter to locate CountryISOmap from array
 */
export const CountryLookup = (lookup: string): CountryISOMap | undefined => {
  return Countries.find((c) => c.Country === lookup || c.alpha2 === lookup)
}

export const DialCodeLookup = (alpha2: string): string | undefined => {
  return CountryLookup(alpha2)?.dialCode;
};
